import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useEffect as l } from "react";
import { ImageCard as s } from "../ImageCard/ImageCard.js";
import { AdjustableTwoColumnGrid as i } from "../AdjustableTwoColumnGrid/AdjustableTwoColumnGrid.js";
import { Concat as n } from "../Concat/Concat.js";
import { SectionedContent as c } from "../SectionedContent/SectionedContent.js";
function h(a) {
  const t = a != null && a.castMember ? a.castMember : { ...a };
  return l(() => {
    const o = document.querySelector("tab-content");
    o && window.scrollTo(0, o.offsetTop - 24);
  }, []), /* @__PURE__ */ r(i, { children: [
    /* @__PURE__ */ e(
      s,
      {
        image: {
          url: t.image.url,
          aspectRatio: t.image.aspectRatio
        }
      }
    ),
    /* @__PURE__ */ e(
      c,
      {
        sections: [
          {
            header: {
              type: "primary",
              title: t.real_name
            },
            content: /* @__PURE__ */ e(n, { list: [
              `<div>${t.name}</div>`,
              t.hometown && t.birthday ? `<strong>Hometown</strong> ${t.hometown} <span class="contact-info-pipe">|</span> <strong>Birthday</strong> ${t.birthday}` : ""
            ] })
          },
          {
            header: {
              type: "secondary",
              title: "Biography"
            },
            content: t.biography
          },
          {
            header: {
              type: "secondary",
              title: "Follow"
            },
            content: t != null && t.facebookHandle || t != null && t.twitterHandle || t.instagramHandle ? /* @__PURE__ */ e(n, { list: [
              t.facebookHandle ? `<span class="cast__follow-platform">Facebook: <a class="cast__follow-link" href="https://facebook.com/${t.facebookHandle}" target="_blank" rel="noreferrer">${t.facebookHandle}</a></span> ` : null,
              t.twitterHandle ? `<span class="cast__follow-platform">Twitter: <a class="cast__follow-link" href="https://twitter.com/${t.twitterHandle}" target="_blank" rel="noreferrer">@${t.twitterHandle}</a></span>` : null,
              t.instagramHandle ? `<span class="cast__follow-platform">Instagram: <a class="cast__follow-link" href="https://instagram.com/${t.instagramHandle}" target="_blank" rel="noreferrer">@${t.instagramHandle}</a></span>` : null
            ] }) : ""
          }
        ]
      }
    )
  ] });
}
export {
  h as CastInfoLayout,
  h as default
};
